import React, { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  SetSliderValueMinMax,
  SetUrlPrefix,
  SetImgPrefix,
  SetSliderValue,
  SetIsSearching,
  SetIsExpanded,
  SetAsyncData,
  SetListingBanner,
  SetFiltersWithoutFilter,
  SetShowFilters,
  SetActiveFilters,
  SetProducts,
  SetPrevProducts,
  SetResultsCount,
  SetFilters,
  SetMasterCategories,
  SetPages,
  SetPage,
  SetSuggestedWords /* , SetFiltersWithoutCategories */,
} from "../../state/actions/index";
import "./ActiveFilter.css";
import Utils from "../../utils/Utils";
import axios from "axios";
import getSymbolFromCurrency from "currency-symbol-map";

const ActiveFilter = (props) => {
  const activeFilters = useSelector((state) => state.activeFilters);
  const searchWord = useSelector((state) => state.searchWord);
  const configFilters = useSelector((state) => state.config.filters);
  const config = useSelector((state) => state.config);
  const card = useSelector((state) => state.config.card);
  const autocomplete = useSelector((state) => state.config.autocomplete);
  const priceFormat = useSelector((state) => state.config.priceGroup.format);
  const currencyCode = useSelector((state) => state.config.priceGroup.currency);
  const advancedCustomization = useSelector(
    (state) => state.advancedCustomization
  );
  const queryOptions = useSelector((state) => state.config.queryOptions);
  const sort = useSelector((state) => state.sort);
  const display = useSelector((state) => state.config.display);
  const isMobile = useSelector((state) => state.isMobile);
  const show = useSelector((state) => state.config.show);
  const products = useSelector((state) => state.products);
  const sliderValue = useSelector((state) => state.sliderValue);
  const sliderValueMinMax = useSelector((state) => state.sliderValue);
  const defaultMasterCategories = useSelector(
    (state) => state.defaultMasterCategories
  );

  const categoryKey = useMemo(() => {
    var valueToReturn = "";
    Object.keys(configFilters).forEach((filter) => {
      if (configFilters[filter].isCategory) valueToReturn = filter;
    });
    return valueToReturn;
  }, [configFilters]);
  var minChars = useMemo(
    () =>
      isMobile ? autocomplete.minChars.mobile : autocomplete.minChars.desktop,
    [isMobile, autocomplete]
  );
  var rows = useMemo(
    () => (isMobile ? queryOptions.rows.mobile : queryOptions.rows.desktop),
    [isMobile, queryOptions]
  );

  var currencySymbol = useMemo(
    () =>
      getSymbolFromCurrency(
        advancedCustomization
          ? advancedCustomization.currencyCode
          : currencyCode
      ),
    [advancedCustomization, currencyCode]
  );

  const dispatch = useDispatch();

  const removeFilter = useCallback(() => {
    var tempActiveFilters = Utils.removeActiveFilter(
      activeFilters,
      props.value,
      configFilters
    );
    dispatch(SetIsSearching(true));
    if (
      tempActiveFilters.length === 0 &&
      searchWord.length < minChars &&
      show.type === "input" &&
      !isMobile
    )
      Utils.closeLayer(display, window.innerWidth <= 768);
    dispatch(SetAsyncData([]));
    var priceGroup = {};
    priceGroup.id =
      window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.visitorType
        ? window.AS_ADVANCED_CONFIG.visitorType
        : config.priceGroup.id;
    priceGroup.currency =
      window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.currencyCode
        ? window.AS_ADVANCED_CONFIG.currencyCode
        : config.priceGroup.currency;
    var localSearchUrl = Utils.getSearchUrl(
      config.baseUrl,
      config.queryOptions,
      priceGroup,
      config.shopId,
      config.jsonFast
    );
    axios
      .get(
        Utils.insertWordInSearchUrl(
          localSearchUrl,
          searchWord,
          tempActiveFilters,
          sort,
          1,
          configFilters,
          rows
        )
      )
      .then((res) => {
        var response = res.data;
        dispatch(SetIsExpanded({}));
        dispatch(SetActiveFilters(tempActiveFilters));
        dispatch(SetPrevProducts(products));
        dispatch(
          SetProducts(
            Utils.refactorUrl(
              response.data,
              response.header.imagePrefix,
              response.header.urlPrefix,
              card.img,
              card.url
            )
          )
        );
        dispatch(SetSuggestedWords(response.suggestions));
        dispatch(SetResultsCount(response.header.results_count));
        if (searchWord.length < minChars && tempActiveFilters.length === 0)
          dispatch(SetShowFilters(false));
        if (props.value.key === "sellingPrice") {
          dispatch(SetSliderValue(Utils.addSliderValue(response, sliderValue)));
          dispatch(
            SetSliderValueMinMax(
              Utils.addSliderValue(response, sliderValueMinMax)
            )
          );
        } /* else if(props.value.key===categoryKey && tempActiveFilters.length>0) dispatch(SetFiltersWithoutCategories(response)) */
        // if(Utils.isMultiChoiceFilter(configFilters,props.value.key) && tempActiveFilters.length>0) dispatch(SetFiltersWithoutFilter({response:response,filterType:props.value.key}))
        if (
          Utils.isMultiChoiceFilter(configFilters, props.value.key) &&
          tempActiveFilters
            .map((activeFilter) => activeFilter.key)
            .includes(props.value.key) &&
          tempActiveFilters.length > 0
        )
          dispatch(
            SetFiltersWithoutFilter({
              response: response,
              filterType: props.value.key,
            })
          );
        else dispatch(SetFilters(response));
        dispatch(
          SetPages(parseInt((response.header.results_count - 1) / rows) + 1)
        );
        dispatch(SetPage(1));
        dispatch(SetListingBanner(response.banners[0]));
        dispatch(
          SetMasterCategories(
            response.stats[categoryKey]
              ? Utils.refactorMasterCategories(
                  Object.keys(response.stats[categoryKey])
                )
              : defaultMasterCategories
          )
        );
        dispatch(SetUrlPrefix(response.header.urlPrefix));
        dispatch(SetImgPrefix(response.header.imagePrefix));
        if (config.webhook.key !== "")
          Utils.getAsyncData(config.webhook, response.data, priceGroup).then(
            (value) => dispatch(SetAsyncData(value.asyncData))
          );
        var websiteSearchBar = document.getElementById(
          "accelasearch-bar-container-container"
        );
        const event = new CustomEvent("as-search-event", {
          detail: {
            searchWord: searchWord,
            filters: tempActiveFilters,
            page: 1,
          },
        });
        websiteSearchBar.dispatchEvent(event);
      })
      .finally(() => dispatch(SetIsSearching(false)));
  }, [
    dispatch,
    activeFilters,
    searchWord,
    isMobile,
    display,
    config,
    show,
    rows,
    props,
    defaultMasterCategories,
    sort,
    sliderValue,
    sliderValueMinMax,
    categoryKey,
    configFilters,
    products,
    minChars,
    card,
  ]);

  return (
    <div className="active-filter" onClick={removeFilter}>
      <span className="value">
        {configFilters[props.value.key]?.isCategory ? (
          Utils.returnLastCategory(props.value.value)
        ) : configFilters[props.value.key]?.type === "slider" ? (
          Utils.setNumberFormat(
            props.value.value[0],
            priceFormat.decimals,
            priceFormat.dec_divider,
            priceFormat.migl_divider
          ) +
          currencySymbol +
          " - " +
          Utils.setNumberFormat(
            props.value.value[1],
            priceFormat.decimals,
            priceFormat.dec_divider,
            priceFormat.migl_divider
          ) +
          currencySymbol
        ) : configFilters[props.value.key]?.type === "rating" ? (
          <span className="icon-container">
            <span>{props.value.value[0]}</span>
            <span className="rating-icon"></span>
          </span>
        ) : (
          props.value.value
        )}
      </span>
      <span className="icon close"></span>
    </div>
  );
};

export default ActiveFilter;
